import React from 'react';
import AdminHeader from '../AdminHeader/AdminHeader';
import './Admin.css'

const Admin = () => {
    return (
        <div>
            
            <AdminHeader></AdminHeader>
            
        </div>
    );
};

export default Admin;